var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sequence-step"},[_c('LmsSwitch',{attrs:{"size":"large","withIcon":true,"value":_vm.computedValue,"updateKey":_vm.updateKey},on:{"update:value":function($event){_vm.computedValue=$event}}}),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('label.sequencedPass')))]),_c('span',[_vm._v(_vm._s(_vm.label))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }